import $ from 'jquery';
import Radio from 'backbone.radio';
    var globalCh = Radio.channel('global');

// Set up record of last N viewed revisions. We'll use this to determine how
// many editor settings we want to keep in localstorage (to prevent it from
// balooning)
  export default function(){
    var RecentRevisions = function(){
        this.revisions = [];
        this.length = 0;
        this.MAX_LENGTH = 200;
      },
      recent_revisions,
      recent_revisions_slug = 'stored_recent_revisions';
    /**
    * Add a revision to the list
    */
    function add(revision_slug) {
      if (revision_slug instanceof Array) {
        this.revisions = revision_slug;
        return;
      }
      if (!revision_slug.length) {
        return console.warn("Must add a string or reset "
                            + "by passing in an entire array");
      }
      this.clear(revision_slug);
      this.revisions.unshift(revision_slug);
      if (this.revisions.length > this.MAX_LENGTH) return this.revisions.pop();
    }
    /**
    * Clear one revision or all revisions
    */
    function clear(revision_slug) {
      if (revision_slug) {
        var index = this.revisions.indexOf(revision_slug);
        if (index > -1) { this.revisions.splice(index, 1); }
      } else {
        this.revisions = [];
      }
    }
    /**
    * Contains the element
    */
    function contains(revision_slug) {
      return (this.revisions.indexOf(revision_slug) > -1);
    }
    /**
    * Persist the recent revisions
    */
    function store() {
      localStorage.setItem(recent_revisions_slug,
                            JSON.stringify(recent_revisions.revisions));
    }
    RecentRevisions.prototype.add = add;
    RecentRevisions.prototype.clear = clear;
    RecentRevisions.prototype.contains = contains;

    recent_revisions = new RecentRevisions();
    globalCh.reply('recent_revisions', function(){ return recent_revisions; });

    this.on('start', function(){
      var stored_recent_revisions = localStorage.getItem(recent_revisions_slug);
      if (!stored_recent_revisions) return;
      recent_revisions.add(JSON.parse(stored_recent_revisions));
    });
    $(window).on('unload', store);
  }

